import { useEffect, useState } from 'react'

import { loadRrweb, loadRrwebPacker } from '@core/rrweb/libs/utils'
import type { RrwebModule, RrwebPackerModule } from '@core/rrweb/types'

/** Lazily loads the rrweb library when it is needed. */
export function useLazyRrwebClient(shouldLoad: boolean) {
  const [rrwebClient, setRrwebClient] = useState<RrwebModule | undefined>(
    undefined,
  )
  const [rrwebPacker, setRrwebPacker] = useState<RrwebPackerModule | undefined>(
    undefined,
  )

  useEffect(() => {
    const loadRrwebClient = async () => {
      const rrweb = await loadRrweb()
      setRrwebClient(rrweb)
    }

    const loadRrwebPackerClient = async () => {
      const rrwebPacker = await loadRrwebPacker()
      setRrwebPacker(rrwebPacker)
    }

    if (shouldLoad) {
      if (!rrwebClient) {
        loadRrwebClient()
      }
      if (!rrwebPacker) {
        loadRrwebPackerClient()
      }
    } else {
      setRrwebClient(undefined)
      setRrwebPacker(undefined)
    }
  }, [rrwebClient, rrwebPacker, shouldLoad])

  return { rrwebClient, rrwebPacker }
}
